import { render, staticRenderFns } from "./CommunityLayout.vue?vue&type=template&id=1ab21386&"
import script from "./CommunityLayout.vue?vue&type=script&lang=js&"
export * from "./CommunityLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports